export const getInflectedWord = (number: number, array: string[]) => {
  const value = Math.abs(number) % 100;
  const num = value % 10;
  if (value > 10 && value < 20) return array[2];
  if (num > 1 && num < 5) return array[1];
  if (num == 1) return array[0];
  return array[2];
};
